// @flow

import React, { type Node } from 'react';
import { usePendingIncomingPayment, getSafeClabeAccount, getSafeClabeReference } from '@tectonics/prs/incoming-payment';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { IfFeature } from '@tectonics/prs/feature';
import { CopyToClipboardIcon, DataList, Term, Definition } from '../../../../commons/molecules';
import { HighlightBox, Padding } from '../../../../commons/atoms';

export function AccountInfo(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const features = useAllFeatures();

  const clabeAccount = getSafeClabeAccount(incomingPayment);
  const clabeReference = getSafeClabeReference(incomingPayment);

  return (
    <HighlightBox>
      <Padding value="0.5em">
        <DataList>
          <IfFeature allFeatures={features} wanted="display_spei_destination_clabe_number">
            <Term>CLABE interbancaria</Term>
            <Definition>
              <CopyToClipboardIcon value={clabeAccount}>{clabeAccount}</CopyToClipboardIcon>
            </Definition>
          </IfFeature>

          <IfFeature allFeatures={features} wanted="display_spei_reference_number">
            <Term>Número de referencia</Term>
            <Definition>
              <CopyToClipboardIcon value={clabeReference}>{clabeReference}</CopyToClipboardIcon>
            </Definition>
          </IfFeature>

          <IfFeature allFeatures={features} wanted="display_spei_destination_bank">
            <Term>Banco destino</Term>
            <Definition>Sistema de transferencia de pagos (STP)</Definition>
          </IfFeature>

          <IfFeature allFeatures={features} wanted="display_spei_destination_beneficiary">
            <Term>Beneficiario</Term>
            <Definition>EBANX</Definition>
          </IfFeature>
        </DataList>
      </Padding>
    </HighlightBox>
  );
}
